import { doc, updateDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { CustomerSupportTicketSortingPriority, TicketStatus } from "../types";

export const updateTicketStatus = async (
  ticketId: string,
  status: TicketStatus,
): Promise<void> => {
  const collectionRef = doc(db, `customerSupportTickets/${ticketId}`);
  await updateDoc(collectionRef, {
    status,
    updatedAt: new Date(),
    sortingPriority: CustomerSupportTicketSortingPriority[status],
  });
};
